<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <!-- Filtres -->
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" style="width:100%;">
        <Form ref="etatForm" :validation-schema="etatSchema" style="width:100%;">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Date Début</label>
                <Field name="dateDebut" type="date" v-model="dateDebut"
                  style="background-color:#fff;"
                  class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="dateDebut" class="text-danger" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Date Fin</label>
                <Field name="dateFin" type="date" v-model="dateFin"
                  style="background-color:#fff;"
                  class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="dateFin" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Utilisateur</label>
                <Field name="selectedUser" v-model="selectedUser" v-slot="{ field }">
                  <Multiselect
                    v-model="field.value"
                    v-bind="field"
                    :options="utilisateursOptions"
                    :searchable="true"
                    no-results-text="Aucun utilisateur trouvé"
                    placeholder="Tous les utilisateurs"
                    :can-clear="true"
                  />
                </Field>
              </div>
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <div class="form-group mb-15 mb-sm-20 mb-md-25 w-100">
                <button type="button" class="btn btn-outline-secondary w-100" @click="reinitialiser">
                  Réinitialiser
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">

      <!-- Blocs résumé -->
      <div class="row g-3 mb-25" v-if="!loading">
        <div class="col-md-3">
          <div class="d-flex align-items-center gap-3 border rounded-3 px-15 py-12"
               style="background:#f0f4ff; min-height:64px;">
            <div class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                 style="width:40px;height:40px;background:#4361ee25;">
              <vue-feather type="shopping-bag" size="18" style="color:#4361ee;" />
            </div>
            <div>
              <div class="fs-12 mb-1" style="color:#666;">Total commandes</div>
              <div class="fs-18 fw-bold" style="color:#4361ee;line-height:1;">{{ totalElements }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="d-flex align-items-center gap-3 border rounded-3 px-15 py-12"
               style="background:#f0fff4; min-height:64px;">
            <div class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                 style="width:40px;height:40px;background:#19875425;">
              <vue-feather type="check-circle" size="18" style="color:#198754;" />
            </div>
            <div>
              <div class="fs-12 mb-1" style="color:#666;">Payées</div>
              <div class="fs-18 fw-bold" style="color:#198754;line-height:1;">{{ totalPayees }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="d-flex align-items-center gap-3 border rounded-3 px-15 py-12"
               style="background:#fff5f5; min-height:64px;">
            <div class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                 style="width:40px;height:40px;background:#dc354525;">
              <vue-feather type="x-circle" size="18" style="color:#dc3545;" />
            </div>
            <div>
              <div class="fs-12 mb-1" style="color:#666;">Annulées</div>
              <div class="fs-18 fw-bold" style="color:#dc3545;line-height:1;">{{ totalAnnulees }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="d-flex align-items-center gap-3 border rounded-3 px-15 py-12"
               style="background:#f0fbff; min-height:64px;">
            <div class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                 style="width:40px;height:40px;background:#0dcaf025;">
              <vue-feather type="dollar-sign" size="18" style="color:#0a8fa3;" />
            </div>
            <div>
              <div class="fs-12 mb-1" style="color:#666;">Montant total (FCFA)</div>
              <div class="fs-16 fw-bold" style="color:#0a8fa3;line-height:1.2;">{{ formatMontant(totalMontant) }}</div>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>


      <!-- Loader -->
      <div v-if="loading" class="text-center py-30">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>

      <!-- Vide -->
      <div v-else-if="commandes.length === 0" class="text-center py-30 text-muted">
        Aucune commande trouvée pour les filtres sélectionnés.
      </div>

      <!-- Tableau -->
      <div v-else class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" style="width:40px;"></th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Réf. Cmd</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Date</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Utilisateur</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Client</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Type</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end">Montant HT</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end">Montant TTC</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center">Statut paie.</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center">Statut liv.</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(commande, index) in commandes" :key="commande.id">

              <!-- Ligne principale -->
              <tr style="cursor:pointer;" @click="toggleExpand(commande.id)">
                <td class="shadow-none text-center">
                  <vue-feather
                    :type="expandedIds.includes(commande.id) ? 'chevron-down' : 'chevron-right'"
                    size="15"
                    style="color:#888;"
                  />
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ commande.refCom }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ format_Date(commande.dateCommande) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ commande.user?.nom }} {{ commande.user?.prenom }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ commande.client?.nomClient }} {{ commande.client?.prenomClient }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  <span class="badge"
                    :class="{
                      'bg-primary': commande.typeCommande === 'Au comptoir',
                      'bg-warning text-dark': commande.typeCommande === 'Sur commande'
                    }">
                    {{ commande.typeCommande }}
                  </span>
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis text-end">
                  {{ formatMontant(commande.montHT) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis text-end">
                  {{ formatMontant(commande.montTTC) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-center">
                  <span class="badge"
                    :class="{
                      'bg-light text-dark': getStatutPaiement(commande) === 'En attente',
                      'bg-success':         getStatutPaiement(commande) === 'Payée',
                      'bg-info':            getStatutPaiement(commande) === 'Partielle',
                      'bg-danger':          getStatutPaiement(commande) === 'Annulée'
                    }">
                    {{ getStatutPaiement(commande) }}
                  </span>
                </td>
                <td class="shadow-none lh-1 fw-medium text-center">
                  <span class="badge"
                    :class="{
                      'bg-light text-dark': getStatutLiv(commande) === 'Non livrée',
                      'bg-success':         getStatutLiv(commande) === 'Livrée',
                      'bg-info':            getStatutLiv(commande) === 'Partielle',
                      'bg-danger':          getStatutLiv(commande) === 'Annulée'
                    }">
                    {{ getStatutLiv(commande) }}
                  </span>
                </td>
              </tr>

              <!-- Sous-tableau produits -->
              <tr v-if="expandedIds.includes(commande.id)">
                <td colspan="10" class="p-0">
                  <div class="px-25 py-15" style="background:#f8f9fa; border-top:2px solid #e2e8f0;">
                    <div class="fs-13 fw-semibold mb-10" style="color:#555;">
                      <vue-feather type="package" size="14" class="me-5" style="color:#6c757d;" />
                      Produits — {{ commande.refCom }}
                    </div>
                    <table class="table table-sm mb-0" style="background:#fff; border:1px solid #e9ecef; border-radius:6px; overflow:hidden;">
                      <thead>
                        <tr style="background:#eef2ff;">
                          <th class="fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12">Produit</th>
                          <th class="fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-center">Qté</th>
                          <th class="fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-end">Prix HT</th>
                          <th class="fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-end">Prix TTC</th>
                          <th class="fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-center">Remise</th>
                          <th class="fs-12 fw-semibold text-body-tertiary text-uppercase py-8 px-12 text-end">Montant TTC</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!commande.proCondiCommandeClients || commande.proCondiCommandeClients.length === 0">
                          <td colspan="6" class="text-center text-muted py-10 fs-13">Aucun produit</td>
                        </tr>
                        <tr v-for="(prod, pIndex) in commande.proCondiCommandeClients" :key="pIndex">
                          <td class="py-8 px-12 fs-13 fw-medium text-black">{{ prod.libelleProduit }}</td>
                          <td class="py-8 px-12 fs-13 text-center fw-semibold">{{ prod.qtite }}</td>
                          <td class="py-8 px-12 fs-13 text-end">{{ formatMontant(prod.prixHt) }}</td>
                          <td class="py-8 px-12 fs-13 text-end">{{ formatMontant(prod.prixTtc) }}</td>
                          <td class="py-8 px-12 fs-13 text-center">
                            <span v-if="prod.remise > 0" class="badge bg-warning text-dark">{{ prod.remise }}%</span>
                            <span v-else class="text-muted">—</span>
                          </td>
                          <td class="py-8 px-12 fs-13 fw-bold text-end">{{ formatMontant(prod.montantTtc) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>

            </template>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils";
import { Form, Field, ErrorMessage } from "vee-validate";
import JwtService from "@/services/JwtService";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import VueFeather from "vue-feather";
import axios from "axios";

export default defineComponent({
  name: "EtatCommandesParUtilisateur",
  components: { Form, Field, ErrorMessage, Multiselect, PaginationComponent, VueFeather },
  setup() {
    const pointventeId = JwtService.getPointDeVenteId();

    const formatDate = (d: Date): string => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const j = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${j}`;
    };

    const today = formatDate(new Date());
    const firstDay = formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

    const etatForm = ref<any>(null);
    const dateDebut = ref<string>(firstDay);
    const dateFin = ref<string>(today);
    const selectedUser = ref<string>("");
    const utilisateursOptions = ref<Array<{ value: string; label: string }>>([]);
    const commandes = ref<Array<any>>([]);
    const loading = ref(false);
    const page = ref(1);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const limit = ref(10);
    const totalPayees = ref(0);
    const totalAnnulees = ref(0);
    const totalMontant = ref(0);

    // Lignes expandées
    const expandedIds = ref<number[]>([]);
    const toggleExpand = (id: number) => {
      const idx = expandedIds.value.indexOf(id);
      if (idx === -1) {
        expandedIds.value.push(id);
      } else {
        expandedIds.value.splice(idx, 1);
      }
    };

    const etatSchema = Yup.object().shape({
      dateDebut: Yup.date().nullable().notRequired(),
      dateFin: Yup.date().nullable().notRequired(),
      selectedUser: Yup.string().notRequired(),
    });

    const formatMontant = (val: number) =>
      new Intl.NumberFormat("fr-FR").format(val ?? 0);

    const getStatutPaiement = (commande: any): string => {
      if (commande.statut === "Annulée") return "Annulée";
      const reglements = commande.reglements || [];
      const dernier = reglements[reglements.length - 1];
      if (!dernier) return "En attente";
      if (dernier.statutPaiement === "paye") return "Payée";
      if (dernier.statutPaiement === "partiel") return "Partielle";
      return "En attente";
    };

    const getStatutLiv = (commande: any): string => {
      if (commande.statut === "Annulée") return "Annulée";
      const livraisons = commande.commandeClientLivres || [];
      return livraisons[livraisons.length - 1]?.statutLiv || "Non livrée";
    };

    const buildParams = (p: number, l: number) => {
      const params = new URLSearchParams();
      params.append("pointvente", pointventeId || "");
      params.append("start", String(p));
      params.append("limit", String(l));
      if (dateDebut.value) params.append("dateDebut", dateDebut.value);
      if (dateFin.value) params.append("dateFin", dateFin.value);
      if (selectedUser.value) params.append("userId", selectedUser.value);
      return params;
    };

    const fetchCommandes = (p = 1, l = 10) => {
      loading.value = true;
      expandedIds.value = [];

      ApiService.get(`/stats/commandesParUtilisateur?${buildParams(p, l).toString()}`)
        .then(({ data }) => {
          commandes.value = data.data?.data || [];
          totalPages.value = data.data?.totalPages || 0;
          totalElements.value = data.data?.totalElements || 0;
          limit.value = data.data?.limit || 10;
        })
        .catch(({ response }) => {
          error(response?.data?.message || "Erreur lors du chargement");
        })
        .finally(() => {
          loading.value = false;
        });

      // Totaux globaux (sans pagination)
      ApiService.get(`/stats/commandesParUtilisateur?${buildParams(1, 9999).toString()}`)
        .then(({ data }) => {
          const toutes: Array<any> = data.data?.data || [];
          totalAnnulees.value = toutes.filter(c => c.statut === "Annulée").length;
          totalPayees.value = toutes.filter(c => {
            const regs = c.reglements || [];
            return regs[regs.length - 1]?.statutPaiement === "paye";
          }).length;
          totalMontant.value = toutes.reduce((acc, c) => acc + (parseFloat(c.montTTC) || 0), 0);
        })
        .catch(() => {});
    };

    const fetchUtilisateurs = async () => {
      try {
        const res = await axios.get(`/users?pointvente=${pointventeId}`);
        const users = res.data?.data?.data || res.data?.data || [];
        utilisateursOptions.value = users.map((u: any) => ({
          value: String(u.id),
          label: `${u.nom} ${u.prenom}`,
        }));
      } catch {
        // silencieux
      }
    };

    const reinitialiser = () => {
      dateDebut.value = firstDay;
      dateFin.value = today;
      selectedUser.value = "";
      page.value = 1;
    };

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      fetchCommandes(page_, limit_);
    };

    watch([dateDebut, dateFin, selectedUser], () => {
      page.value = 1;
      fetchCommandes(1, limit.value);
    });

    onMounted(() => {
      fetchUtilisateurs();
      fetchCommandes(1, limit.value);
    });

    return {
      etatForm,
      etatSchema,
      dateDebut,
      dateFin,
      selectedUser,
      utilisateursOptions,
      commandes,
      loading,
      page,
      totalPages,
      totalElements,
      totalPayees,
      totalAnnulees,
      totalMontant,
      limit,
      expandedIds,
      toggleExpand,
      format_Date,
      formatMontant,
      getStatutPaiement,
      getStatutLiv,
      handlePaginate,
      reinitialiser,
    };
  },
});
</script>
